import React from 'react'; // eslint-disable-line no-unused-vars
import { connect } from 'react-redux';
import WelcomeView from '../components/WelcomeView'
import { currentUser } from '../../reducer';
const mapStateToProps = (state) => {
  return {
    current_user_id: currentUser(state).get("id")
  }
};

const mapDipatchToProps = (dispatch, ownProps) => {
  return {
    // onSubmit: ({pin}) => {
    //   dispatch(submitCodeLoginForm(pin,window.getCookie("udid")));
    // }
  }
}

export const Welcome = connect(mapStateToProps,mapDipatchToProps)(WelcomeView);

export default Welcome;



// WEBPACK FOOTER //
// ./src/snapit_app/containers/Welcome.js